export default [
	'startDate',
	'endDate',
	'date',
	'artistInitiated',
	'title',
	'comment',
	'name',
	'slug',
	'eventName',
	'platformName',
	'exhibitionName',
	'exhibitionLocation',
	'location',
	'ownerWallet',
	'receiverWallet',
	'ownerAddress',
	'receiverAddress',
	'exhibitionWallet',
	'exhibitionDetails',
	'url',
	'imageUrl',
	'externalLink',
	'lendeeAddress',
	'lenderAddress',
	'lendStatus',
	'buyerAddress',
	'sellerAddress',
	'artistName',
	'artistAvatar',
	'amount',
	'currency',
	'additionalInformation',
	'description',
	'publisher',
	'author',
	'transactionHash',
	'countersignStatus',
	'countersignRequirement',
	'ipfsCID',
	'arweaveTxId',
	'tweetUrl',
	'castUrl',
	'instagramUrl',
	'ipfsUrl',
	'originalMetadataIPFSCID',
	'originalAttestationIPFSCID',
	'arweaveUrl',
	'timestamp',
	'nfts',
	'GroupNFTsCID',
	'marketplaceUrls',
	'fileName',
	'fileType',
	'fileExtension',
	'fileSize',
	'pageCount',
]
